export const SIZES = [null, 'large', 'small'];

export default {};
